import React, { Component } from 'react'

export class Loader extends Component {
  render() {
    return (
      <div data-test="LoaderComponent">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }
}

export default Loader
